module.exports = __webpack_public_path__ + "static/media/vegitables_69.915f3f9b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_69.csv
// module id = 656
// module chunks = 0